define('lib/Podio.PageVisibility',['require','lib/Podio.Browser','signals'],function(require) {

  /*
   * Podio Page Visibility
   * Written by: Kenneth Auchenberg (Podio)
   *
   * Based on isVis - v0.5.5 Aug 2011 (Copyright (c) 2011 Addy Osmani, https://gist.github.com/1122546)
   */

  var podioBrowser = require('lib/Podio.Browser');
  var signalsLib = require('signals');

  var signals = {
    onHidden            : new signalsLib.Signal(),
    onVisible           : new signalsLib.Signal(),
    onVisibilityChange  : new signalsLib.Signal()
  };

  var currentPrefix = podioBrowser.prefix;

  function onVisible() {
    signals.onVisible.dispatch();
    signals.onVisibilityChange.dispatch('visible');
  }

  function onHidden() {
    signals.onHidden.dispatch();
    signals.onVisibilityChange.dispatch('hidden');
  }

  function isHidden() {
    return document[podioBrowser.prefixed('hidden')] === true;
  }

  function isVisible() {
    return !isHidden();
  }

  function onNativeEvent() {
    if(isHidden()) {
      onHidden();
    } else {
      onVisible();
    }
  }

  function listen() {
    document.addEventListener(currentPrefix + 'visibilitychange', onNativeEvent, true);
  }

  function stopListening() {
    document.removeEventListener(currentPrefix + 'visibilitychange', onNativeEvent, true);
  }

  listen();

  return {
    onHidden  : signals.onHidden,
    onVisible : signals.onVisible,
    isHidden  : isHidden,
    isVisible : isVisible,
    stopListening: stopListening
  };

});

